import {
    SELECT_VISIBLE_ROSTER_ATHLETES,
    DESELECT_ROSTER_ATHLETES,
} from 'shared_redux/actions';

export const selectVisibleAthletes = athleteIds => ({ type: SELECT_VISIBLE_ROSTER_ATHLETES, athleteIds });

export const deselectAthletes = () => ({ type: DESELECT_ROSTER_ATHLETES });
